import React from 'react';
import { Star } from 'lucide-react';
import { cn } from '@/lib/utils';
import { getStarColorClass } from '@/lib/starColors';

type StarRatingProps = {
  value?: number | null;
  max?: number;
  size?: number;
  className?: string;
};

export default function StarRating({ value = 0, max = 5, size = 16, className }: StarRatingProps) {
  const normalized = Math.max(0, Math.min(max, Number(value) || 0));
  const colorClass = getStarColorClass(normalized);

  return (
    <span className={cn('inline-flex items-center gap-1 align-middle', className)}>
      {Array.from({ length: max }).map((_, i) => {
        const fill = Math.max(0, Math.min(1, normalized - i));
        return (
          <span
            key={`star-${i}`}
            className="relative inline-block"
            style={{ width: size, height: size }}
            aria-hidden
          >
            <Star size={size} className="text-muted-foreground" />
            <span
              className="absolute left-0 top-0 h-full overflow-hidden"
              style={{ width: `${fill * 100}%` }}
            >
              <Star size={size} className={colorClass} />
            </span>
          </span>
        );
      })}
    </span>
  );
}
